import styled from 'styled-components'

const VaultItem = ({ nft, type, action }) => {
  const image = nft?.json ? nft?.json?.image : nft?.externalMetadata?.image;
  const name = nft?.json ? nft?.json?.name : nft?.externalMetadata?.name;

  return (
    <VaultItemContainer>
      <img src={image} alt={name} />
      <VaultItemDetailsContainer>
        <div>
          <p style={{ fontWeight: 600 }}>{name}</p>
        </div>
        <div>
          <button onClick={() => action(nft)}>
            {type === 'staked' ? 'Unstake' : 'Stake'}
          </button>
        </div>
      </VaultItemDetailsContainer>
    </VaultItemContainer >
  )
}

export default VaultItem

const VaultItemContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
  text-align: left;

  img {
    border-radius: 4px;
    height: 120px;
    margin-right: 8px;
    width: 120px;
  } 
`

const VaultItemDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    font-weight: 400;
    margin: 0;
  }

  button {
    padding-left: 15px;
    padding-right: 15px;

    svg {
      margin-right: 5px;
      position: relative;
      top: -1px;
    }

    &:disabled{ 
      background: #a5461d;
      border-color: #a5461d;

      cursor: not-allowed;
      opacity: 0.5;

      &:hover {
        border-color: #a5461d;
      }
    }
  }
`